<template lang="html">
  <v-container class='fluid'>
    <v-layout align-center justify-center>
      <v-flex xs12>
        <v-card class="text-xs-center">
          <basic-toolbar :title="'Pesquisa'"></basic-toolbar>
          <v-card-text>

            <v-layout>
              <router-link to="/pesquisa/consulta-projetos" class="opcaoAdministrador">
                <a>Consultar Projetos de Pesquisa</a>
              </router-link>
            </v-layout>

            <v-layout>
              <router-link to="pesquisa/novo-projeto" class="opcaoAdministrador">
                <a>Novo Projeto de Pesquisa</a>
              </router-link>
            </v-layout>

            <v-layout>
              <router-link to="pesquisa/meus-projetos" class="opcaoAdministrador">
                <a>Meus Projetos de Pesquisa</a>
              </router-link>
            </v-layout>

           
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import BasicToolbar from '@/components/toolbars/basic-toolbar'
  import ToolTip from '@/components/app-layouts/app-tooltip/tooltip'
  import DataMenu from '@/components/c-date-menu'
  import projetos from '@/utils/projetos'
  import { mapGetters, mapActions } from 'vuex'

  export default {
    props: ['idProjeto'],
    data: () => ({
      dialog: false,
      formularioValido: false,
      projeto: {
        situacao: {},
        tipoPublico: {},
        classificacoesPrimariaSecundaria: [{}, {}]
      },
      aprovacao: {
        dataAprovacaoCamaraExtensao: '',
        justificativaObservacao: ''
      },
      regrasBasicas: [
        (input) => !!input || 'Este campo é obrigatório'
      ],
      assuntoSummaryRules: [
        (input) => input.length <= 2000 || 'Este campo não pode possuir mais que 2000 caracteres'
      ]
    }),
    computed: {
      ...mapGetters('auth', ['logged', 'username', 'nome', 'administrador', 'usuarioPROEX', 'permissaoCriarProjetoExtensao', 'permissaoCriarProjetoPesquisa'])
    },
    methods: {
      ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),
      cancelar: function () {
        this.$router.push({name: 'ProjetosAguardandoAprovacao'})
      },
      aprovarProjeto: function () {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Aprovando projeto...' })
        projetos.postAprovarProjeto(this.idProjeto, this.aprovacao)
        .then(response => {
          this.SHOW_SNACKBAR({snackbarType: 'success', snackbarText: response.body.mensagem})
          this.$router.push({name: 'ProjetosAguardandoAprovacao'})
        })
        .catch(error => {
          this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Aprovando projeto...' })
        })
      }
    },
    mounted () {
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' })
      projetos.getProjeto(this.idProjeto)
      .then(response => {
        this.projeto = response.data
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' })
      })
    },
    components: {
      'basic-toolbar': BasicToolbar,
      'tooltip': ToolTip,
      'c-date-menu': DataMenu
    }
  }
</script>

<style lang="css">
  .menu {
    display: block !important;
  }

  .no-resize div textarea{
    resize: none;
  }
  .input-group__icon-cb {
    cursor: pointer !important;
  }

  .opcaoAdministrador {
    font-size: 1.5em;
    margin-bottom: 1em;
  }

</style>



// WEBPACK FOOTER //
// pesquisa.vue?116e4176